import { 
  Target, 
  Rocket, 
  Users, 
  ClipboardCheck, 
  FileText, 
  LineChart,
  Globe,
  Shield,
  Mail,
  Linkedin,
  Handshake,
  UserCog
} from "lucide-react";

const Services = () => {
  const services = [
    {
      icon: Target,
      title: "Strategic Advisory",
      description: "We work with founders to shape a clear, compelling and investor-ready strategy.",
      items: [
        "Investment readiness audit",
        "TRL assessment & dual-use classification",
        "CE / EN / ISO compliance guidance",
        "Business model analysis",
        "Go-to-market strategy for EU/UK markets",
        "Risk assessment & mitigation plan",
      ],
    },
    {
      icon: Rocket,
      title: "Fundraising Execution",
      description: "We act as your part-time fundraising team—hands-on, not advisory-only.",
      items: [
        "Pitch deck creation (dual-use narrative + investor messaging)",
        "Financial model & manufacturing economics",
        "Investor pipeline creation (120–200 EU/UK investors)",
        "Email + LinkedIn outreach",
        "Warm introductions through our partner network",
        "Preparation for investor meetings & technical Q&A",
        "Due diligence support",
      ],
    },
    {
      icon: UserCog,
      title: "Fractional Leadership",
      description: "For companies needing temporary executive support.",
      items: [
        "Fractional CMO (strategy, messaging, GTM execution)",
        "Fractional go-to-market and BD leadership",
        "Legal and compliance advisory in collaboration with licensed partners",
        "Hands-on support with fundraising, board communication, and investor updates",
      ],
      badge: "Optional",
    },
  ];

  return (
    <section id="services" className="py-24 md:py-32 bg-background">
      <div className="container px-6">
        {/* Section header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 line-glow inline-block">
            What We Do
          </h2>
          <p className="text-lg text-muted-foreground mt-6">
            End-to-end support from strategy to successful fundraise
          </p>
        </div>

        {/* Services grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative p-8 rounded-xl border border-border bg-card hover:border-primary/30 transition-all duration-300 hover:shadow-card"
            >
              {/* Badge */}
              {service.badge && (
                <span className="absolute top-4 right-4 text-xs font-medium px-2 py-1 rounded-full bg-primary/10 text-primary">
                  {service.badge}
                </span>
              )}

              {/* Icon */}
              <div className="w-12 h-12 rounded-lg gradient-gold flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <service.icon className="w-6 h-6 text-primary-foreground" />
              </div>

              {/* Content */}
              <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                {service.title}
              </h3>
              <p className="text-muted-foreground mb-6 text-sm">
                {service.description}
              </p>

              {/* Items list */}
              <ul className="space-y-3">
                {service.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start gap-3 text-sm text-muted-foreground">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
